import React, {useState} from "react";
import Button from "../../NewComponent/Button/Button";
import { ReactComponent as ReloadIcon } from "../../Icons/reload.svg";
import SelectComp from "../../NewComponent/Select/Select";
import { generateAIText, generateGenAi } from "../../API/api";
import { bindActionCreators } from "redux";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../Action";
import AnswerBoxForSourceSelection from "../../NewComponent/answerBox/AnswerBoxForSourceSelection";
import { ReactComponent as CheckBoxIcon } from "../../Icons/checkbox.svg";
import { ReactComponent as CheckBoxSelectedIcon } from "../../Icons/check-square.svg";
export default function RenegerateBox() {
  const searchState = useSelector((state) => state.search);
  const [ddval, setDdVal] =useState('all');
  const [ddMval, setDdMVal] =useState('all');
  const [dropOptions, setDropOptions] = useState([]);
  const [searchData, setSearchData] =useState(searchState.origRawSearchedData);
  const dispatch = useDispatch();
  const {
    updateShortCheckedTypeSP,
    updateSalesSummaryTypeSP,
    UpdateGenerativeAITextWithDiffLang,
    isRegeneratingGenAiText,
    selectedSourcesSP,
  } = bindActionCreators(Actions, dispatch);

  const containerStyle = {
    border: "1px solid #E0E2E6",
    borderRadius: "16px",
    background: "#FFFFFF",
    boxShadow: "0px 4px 16px 0px #1018280F",
    padding: "24px 36px 36px 36px",
    minHeight: "100px",
  };
  const filterDocName = (arr) => {
    let newArr = [{ value: "all", label: "All" }];
    arr.map((obj) => {
      newArr.push({
        value: obj,
        label:obj,
      });
    });
    return newArr;
  };
  const onClickSources = (arr) => {
    selectedSourcesSP(arr);
  };
  const onChangeDd = (data) =>{
    setDropOptions([]);
    setDdVal(data);
    setDdMVal('all');
    if(data==='all'){
    setSearchData(searchState.origRawSearchedData);
    }else{
      setSearchData(searchState.origRawSearchedData.filter(obj=>obj.newDocType===data));
      setDropOptions([...new Set(searchState.origRawSearchedData.filter(obj=>obj.newDocType===data).map(obj2=>obj2.docName))]);
    }
  }
  const onChangeDdM = (data) =>{
    setDdMVal(data);
    if(data==='all'){
      let newData = searchState.origRawSearchedData.filter(obj=>{
        if(obj.docType===ddval){
          return obj;
        }
      })
      setSearchData(newData);
    }else{
    let newData = searchState.origRawSearchedData.filter(obj=>{
      if(obj.docType===ddval && obj.docName=== data){
        return obj;
      }
    })
    setSearchData(newData);
  }
  }
  const filterDocType = (arr) => {
    let newArr = [{ value: "all", label: "All" }];
    arr.map((obj) => {
      newArr.push({
        value: obj,
        label:
          obj === "expertqa"
            ? "Expert QA"
            : obj === "urlcrawl"
            ? "Url Crawl"
            : obj,
      });
    });
    return newArr;
  };
  const onChangeDropdown1 = (val) => {
    updateSalesSummaryTypeSP(val);
    isRegeneratingGenAiText(true);
    const payload = {
      question: searchState.inputValue,
      language: searchState.lang,
      salesSummary: val === "Technical" ? false : true,
      shortSummary: searchState.isShortChecked === "Detailed" ? false : true,
      generatedText: searchState.origGenerativeText,
    };
    generateAIText(payload).then((res) => {
      if (res === undefined) return;
      UpdateGenerativeAITextWithDiffLang(res.data.data);
      isRegeneratingGenAiText(false);
    });
  };
  const onChangeDropdown2 = (val) => {
    updateShortCheckedTypeSP(val);
    isRegeneratingGenAiText(true);
    const payload = {
      question: searchState.inputValue,
      language: searchState.lang,
      salesSummary: searchState.isSalesSummary === "Technical" ? false : true,
      shortSummary: val === "Detailed" ? false : true,
      generatedText: searchState.origGenerativeText,
    };
    generateAIText(payload).then((res) => {
      if (res === undefined) return;
      UpdateGenerativeAITextWithDiffLang(res.data.data);
      isRegeneratingGenAiText(false);
    });
  };
  const getAnswerUuid = (arr)=>{
    let newArr = []
    arr.filter(obj=>{
        obj.answers.filter(obj2=>{
            newArr.push(obj2.answerUuid);
        })
    })
    return newArr;
}
  const onClickRegenerate = () => {
    let newArr = [];
        let newArr2 = searchState.origRawSearchedData.map(obj=>{
            obj.answers.filter(obj2=>{
                obj2.contextData = (obj2.answerText===undefined || obj2.answerText===null || obj2.answerText==="")?obj.contextData:obj2.answerText;
                newArr.push(obj2);
            })
        })
        let desiredAnswers = newArr.filter(item => searchState.selectedSources.includes(item.answerUuid));
        let arf = desiredAnswers.map(obj=>{
            return obj.contextData;
        })
        let payload = {
            paragraphs:arf,
            query:searchState.inputValue,
            summaryUuid:searchState.summaryUuid,
            language:searchState.lang,
            shortSummary:searchState.isShortChecked==='Detailed'?false:true,
            salesSummary:searchState.isSalesSummary==='Technical'?false:true
        }
        isRegeneratingGenAiText(true);
        generateGenAi(payload).then(res=>{
          if (res===undefined) return;

      if(res.data.data==="I don't know."){
          setTimeout(() => {
              UpdateGenerativeAITextWithDiffLang('Machine is not able to generate the text with the selected sources.\n**Try selecting more sources.')
              isRegeneratingGenAiText(false);
          }, 4000);
      }else{
          UpdateGenerativeAITextWithDiffLang(res.data.data);
          isRegeneratingGenAiText(false);
      }
     })
  };
  const onChangeCheckbox = (flag)=>{
    let currentdataIds = getAnswerUuid(searchData);
    let selectedData = searchState.selectedSources;
    if(!flag){
        let newData = selectedData.filter(element => !currentdataIds.includes(element))
        selectedSourcesSP(newData);
    }
    if(flag){
        let newData = [...selectedData,...currentdataIds]
        selectedSourcesSP([...new Set(newData)]);
        // selectedSourcesSP(newData);

    }
}

  return (
    <>
      <div style={containerStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              className="subTextTitle"
              style={{ fontSize: "14px", fontWeight: "400" }}
            >
              {getAnswerUuid(searchData).every(element => searchState.selectedSources.includes(element))?<CheckBoxSelectedIcon onClick={()=>onChangeCheckbox(false)} />:<CheckBoxIcon onClick={()=>onChangeCheckbox(true)} />}
            &nbsp;
            </span>
            &nbsp;
            <SelectComp val={ddval} onChangeFunc={onChangeDd} isString={false} options={filterDocType([...new Set(searchState.origRawSearchedData.map(obj=>obj.newDocType))])} width={"140px"} size={"large"} />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <SelectComp
                isString={false}
                val={searchState.isSalesSummary}
                onChangeFunc={onChangeDropdown1}
                options={[
                  { label: "Technical", value: "Technical" },
                  { label: "Business", value: "Business" },
                ]}
                width={"120px"}
                size={"large"}
              />
              &nbsp;&nbsp;
              <SelectComp
                onChangeFunc={onChangeDropdown2}
                isString={false}
                val={searchState.isShortChecked}
                width={"120px"}
                size={"large"}
                options={[
                  { label: "Detailed", value: "Detailed" },
                  { label: "Short", value: "Short" },
                ]}
              />
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div>
              <Button
                type={"primary"}
                onClickFunc={onClickRegenerate}
                text={
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <ReloadIcon />
                    &nbsp;&nbsp;Regenerate Answer
                  </span>
                }
              />
            </div>
          </div>
        </div>
        {/* {ddval !=='all'&& ddval !=='Email'&& ddval !=='Thread'&& ddval !=='expertqa'&&<div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="mt-2"
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <SelectComp val={ddMval} onChangeFunc={onChangeDdM} isString={false} options={filterDocName(dropOptions)} width={"200px"} size={"large"} />
          </div>
        </div>} */}
        <div className="mt-4">
          {searchData.map((que) => {
            // console.log("mapp",que)
            return que.answers.map((ans) => {
              return (
                <AnswerBoxForSourceSelection
                  question={que}
                  data={ans}
                  onClickFunc={onClickSources}
                  options={searchState.selectedSources}
                />
              );
            });
          })}
        </div>
      </div>
    </>
  );
}
